import { X } from "@phosphor-icons/react";
import React from "react";
import { Button } from "../Button";
import HideComponentWrapper from "../HideComponentWrapper";
import IconButton from "../IconButton";
import styles from "./Modal.module.css";
import { IModalWrapperProps } from "../../models/IModalWrapperProps";

const ModalWrapper: React.FC<IModalWrapperProps> = (props: IModalWrapperProps) => {
	return (
		<div className={styles.modal_wrapper}>
			<HideComponentWrapper hidden={!!props.hideHeader}>
				<div className={styles.modal_header}>
					<HideComponentWrapper hidden={!props.featuredIcon}>{props.featuredIcon}</HideComponentWrapper>
					<HideComponentWrapper hidden={!!props.hideCloseButton}>
						<IconButton
							className={styles.icon_close}
							buttonType="text"
							onClick={props.handleClose ? props.handleClose : () => {}}
							size="medium"
							variant="secondary"
						>
							<X size={"1.5rem"} />
						</IconButton>
					</HideComponentWrapper>
				</div>
			</HideComponentWrapper>
			<div className={styles.modal_body}>{props.children}</div>
			<HideComponentWrapper hidden={!!props.hideFooter}>
				<div className={styles.modal_footer}>
					<Button
						className={styles.modal_footer_btn}
						buttonType="button"
						label={props.cancelButtonText ?? "Close"}
						onClick={props.handleClose}
						size="medium"
						variant="secondary"
					/>
					<Button
						className={styles.modal_footer_btn}
						buttonType="button"
						label={props.submitButtonText ?? "Submit"}
						onClick={props.handleSubmit}
						size="medium"
						variant="primary"
					/>
				</div>
			</HideComponentWrapper>
		</div>
	);
};
ModalWrapper.displayName = "ModalWrapper";
export default ModalWrapper;
